/* Elegancecoque - favoris : cœur sur les cartes et les fiches produits (cœur discret à droite du titre), cœur dans l'en-tête, page « Mes favoris ».
   Les favoris sont gardés dans ce navigateur (localStorage « ec-wishlist ») et retrouvés à chaque visite. */
(function(){
if(window.LuxeWishlist){return;}
var doc=document,KEY='ec-wishlist',MAX=100;
var cfg={page:'/pages/favoris',money:'{{amount}} DH'};
try{var cn=doc.getElementById('lwl-config');if(cn){var cj=JSON.parse(cn.textContent);if(cj.page){cfg.page=cj.page;}if(cj.money){cfg.money=cj.money;}}}catch(e){}
var ROOT=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
var HEART='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.2s-7.2-4.3-8.8-9C2.1 8 4.2 4.9 7.4 4.9c2 0 3.5 1.1 4.6 2.7 1.1-1.6 2.6-2.7 4.6-2.7 3.2 0 5.3 3.1 4.2 6.3-1.6 4.7-8.8 9-8.8 9z"/></svg>';
var CARDS=[['.lcard','.lcard__name'],['.lcg-card','.lcg-card__title'],['.ec-p','.ec-p__name'],['.lac-card','.lac-card__title'],['.lau__card[data-lau-card]','.lau__name'],['.lmk-p','.lmk-p__name']];

function load(){try{var a=JSON.parse(window.localStorage.getItem(KEY)||'[]');return Array.isArray(a)?a.filter(function(x){return x&&x.h;}):[];}catch(e){return [];}}
function save(a){try{window.localStorage.setItem(KEY,JSON.stringify(a.slice(0,MAX)));}catch(e){}}
function has(h){return load().some(function(x){return x.h===h;});}
function toggle(item){
 var a=load(),i=-1;
 a.forEach(function(x,k){if(x.h===item.h){i=k;}});
 if(i>-1){a.splice(i,1);}else{a.unshift({h:item.h,t:item.t||'',i:item.i||''});}
 save(a);sync();
 try{doc.dispatchEvent(new CustomEvent('lwl:change',{detail:{handle:item.h,on:i<0}}));}catch(e){}
 return i<0;
}
function handleOf(href){try{var m=new URL(href,location.href).pathname.match(/\/products\/([^\/?#]+)/);return m?decodeURIComponent(m[1]):'';}catch(e){return '';}}
function setState(b){
 var on=has(b.getAttribute('data-lwl'));
 b.setAttribute('aria-pressed',on?'true':'false');
 b.setAttribute('aria-label',on?'Retirer des favoris':'Ajouter aux favoris');
 b.classList.toggle('is-on',on);
 var t=b.querySelector('.lwl-btn__t'),tx=on?'Dans vos favoris':'Ajouter aux favoris';if(t&&t.textContent!==tx){t.textContent=tx;}
}
function makeBtn(item,cls,withText){
 var b=doc.createElement('button');b.type='button';b.className='lwl-btn '+cls;
 b.setAttribute('data-lwl',item.h);b.__lwl=item;
 b.innerHTML=HEART+(withText?'<span class="lwl-btn__t"></span>':'');
 setState(b);return b;
}
function sync(){
 [].forEach.call(doc.querySelectorAll('[data-lwl]'),setState);
 var n=load().length;
 [].forEach.call(doc.querySelectorAll('[data-lwl-count]'),function(c){if(c.textContent!==String(n)){c.textContent=n;}c.hidden=n===0;});
 [].forEach.call(doc.querySelectorAll('[data-lwl-head]'),function(a){a.setAttribute('aria-label','Mes favoris'+(n?' ('+n+')':''));});
}
function enhanceCards(ctx){
 /* 30-10 : lectures groupées puis écritures (avant : getComputedStyle entre deux ajouts, pour chaque carte) */
 var todo=[];
 CARDS.forEach(function(pair){
  [].forEach.call((ctx||doc).querySelectorAll(pair[0]),function(el){
   if(el.__lwl||el.closest('[data-lwl-page]')){return;}
   var a=el.querySelector('a[href*="/products/"]');if(!a){return;}
   var h=handleOf(a.getAttribute('href'));if(!h){return;}
   el.__lwl=true;
   var n=el.querySelector(pair[1]),img=el.querySelector('img');
   todo.push({el:el,item:{h:h,t:((n&&n.textContent)||a.getAttribute('aria-label')||'').trim(),i:img?(img.getAttribute('src')||''):''}});
  });
 });
 var stat=todo.map(function(x){return window.getComputedStyle(x.el).position==='static';});
 todo.forEach(function(x,i){
  if(stat[i]){x.el.style.position='relative';}
  x.el.appendChild(makeBtn(x.item,'lwl-btn--card',false));
 });
}
function enhanceProduct(){
 var m=location.pathname.match(/\/products\/([^\/?#]+)/);if(!m||doc.querySelector('.lwl-btn--pdp')){return;}
 var h=decodeURIComponent(m[1]);
 var main=doc.getElementById('MainContent')||doc.body;
 var h1=main.querySelector('h1');if(!h1){return;}
 var img=main.querySelector('img');
 var b=makeBtn({h:h,t:h1.textContent.trim(),i:img?(img.getAttribute('src')||''):''},'lwl-btn--pdp',false);
 var box=h1.parentNode;
 if(window.getComputedStyle(box).position==='static'){box.style.position='relative';}
 h1.style.paddingRight='52px';
 box.appendChild(b);
}
function enhanceHeader(){
 var right=doc.querySelector('.lt-header__right');if(!right||right.querySelector('[data-lwl-head]')){return;}
 var a=doc.createElement('a');a.className='lt-icon lwl-head';a.href=cfg.page;a.setAttribute('data-lwl-head','');
 a.innerHTML=HEART+'<span class="lwl-count" data-lwl-count hidden>0</span>';
 var bag=right.querySelector('.lt-bag');right.insertBefore(a,bag||null);
}
function money(cents){
 var v=(Number(cents)||0)/100,fmt=cfg.money||'{{amount}}';
 function num(d,ts,ds){var s=v.toFixed(d).split('.');s[0]=s[0].replace(/\B(?=(\d{3})+(?!\d))/g,ts);return s.length>1?s[0]+ds+s[1]:s[0];}
 return fmt.replace(/\{\{\s*(\w+)\s*\}\}/,function(_,k){
  if(k==='amount_no_decimals'){return num(0,',','.');}
  if(k==='amount_with_comma_separator'){return num(2,'.',',');}
  if(k==='amount_no_decimals_with_comma_separator'){return num(0,'.',',');}
  if(k==='amount_with_space_separator'){return num(2,' ',',');}
  return num(2,',','.');
 }).replace(/<[^>]*>/g,'');
}
function esc(t){var d=doc.createElement('span');d.textContent=t==null?'':String(t);return d.innerHTML;}
var pageSeq=0;
function renderPage(){
 var root=doc.querySelector('[data-lwl-page]');if(!root){return;}
 var grid=root.querySelector('[data-lwl-grid]'),empty=root.querySelector('[data-lwl-empty]'),count=root.querySelector('[data-lwl-pcount]');
 var list=load(),seq=++pageSeq;
 count.textContent=list.length?(list.length+' coque'+(list.length>1?'s':'')+' en favori'):'';
 if(!list.length){grid.innerHTML='';empty.hidden=false;return;}
 empty.hidden=true;
 Promise.all(list.map(function(x){
  return window.fetch(ROOT+'products/'+encodeURIComponent(x.h)+'.js',{headers:{Accept:'application/json'}})
   .then(function(r){if(r.status===404){return {gone:true,h:x.h};}if(!r.ok){throw new Error('net');}return r.json();})
   .catch(function(){return {h:x.h,title:x.t,featured_image:x.i,offline:true};});
 })).then(function(res){
  if(seq!==pageSeq){return;}
  var gone=res.filter(function(p){return p&&p.gone;}).map(function(p){return p.h;});
  if(gone.length){save(load().filter(function(x){return gone.indexOf(x.h)<0;}));sync();}
  var ok=res.filter(function(p){return p&&!p.gone;});
  if(!ok.length){grid.innerHTML='';empty.hidden=false;count.textContent='';return;}
  count.textContent=ok.length+' coque'+(ok.length>1?'s':'')+' en favori';
  grid.innerHTML='';
  ok.forEach(function(p){
   var h=p.handle||p.h,url=ROOT+'products/'+encodeURIComponent(h),img=p.featured_image||'';
   if(img&&img.indexOf('//')===0){img='https:'+img;}
   var li=doc.createElement('li');li.className='lwl-card';
   li.innerHTML='<a class="lwl-card__media" href="'+url+'">'+(img?'<img src="'+esc(img)+(img.indexOf('?')>-1?'&':'?')+'width=600" alt="'+esc(p.title)+'" loading="lazy">':'')+'</a>'+
    '<a class="lwl-card__name" href="'+url+'">'+esc(p.title)+'</a>'+
    (p.offline?'':'<p class="lwl-card__price">'+(p.price_varies?'À partir de ':'')+esc(money(p.price))+'</p>')+
    (p.available===false?'<span class="lwl-card__off">Épuisé</span>':'');
   li.appendChild(makeBtn({h:h,t:p.title,i:img},'lwl-btn--card',false));
   grid.appendChild(li);
  });
 });
}
function css(){
 if(doc.getElementById('lwl-css')){return;}
 var s=doc.createElement('style');s.id='lwl-css';
 s.textContent='.lwl-btn{position:absolute;top:8px;right:8px;z-index:3;display:flex;align-items:center;justify-content:center;width:36px;height:36px;margin:0;padding:0;border:1px solid rgba(200,169,106,.9);border-radius:50%;background:rgba(255,253,248,.94);color:#8a6a2c;cursor:pointer;touch-action:manipulation;-webkit-tap-highlight-color:transparent;transition:transform .15s ease,background .2s ease,color .2s ease}'+
 '.lwl-btn::before{content:"";position:absolute;inset:-4px}'+
 '.lwl-btn svg{width:18px;height:18px;fill:none;stroke:currentColor;stroke-width:1.7;stroke-linejoin:round}'+
 '.lwl-btn.is-on{border-color:#111;background:#111;color:#e3c27a}.lwl-btn.is-on svg{fill:currentColor}'+
 '.lwl-btn:focus-visible{outline:2px solid #aa7814;outline-offset:2px}.lwl-btn.is-pop{transform:scale(1.15)}'+
 '.lwl-btn--pdp{top:0;right:0;width:42px;height:42px;margin:0;padding:0;border-radius:50%}'+
 '.lwl-btn--pdp svg{width:20px;height:20px}'+
 '.lwl-head{position:relative}.lwl-head svg{fill:none}'+
 '.lwl-count{position:absolute;top:3px;right:0;min-width:17px;height:17px;padding:0 4px;border-radius:9px;background:#D4AF37;color:#050505;font-size:10px;font-weight:600;line-height:17px;text-align:center}.lwl-count[hidden]{display:none}'+
 '@media(max-width:359px){.lt-header__right .lt-icon{width:34px}}'+
 '@media(prefers-reduced-motion:reduce){.lwl-btn{transition:none}}';
 doc.head.appendChild(s);
}
doc.addEventListener('click',function(e){
 var b=e.target&&e.target.closest?e.target.closest('.lwl-btn'):null;if(!b){return;}
 e.preventDefault();e.stopPropagation();
 var on=toggle(b.__lwl||{h:b.getAttribute('data-lwl')});
 b.classList.add('is-pop');window.setTimeout(function(){b.classList.remove('is-pop');},160);
 if(!on&&b.closest('[data-lwl-page]')){renderPage();}
},true);
window.addEventListener('storage',function(e){if(e.key===KEY){sync();renderPage();}});
var t=0;
function run(){css();enhanceHeader();enhanceCards();enhanceProduct();sync();}
function boot(){
 run();renderPage();
 if(window.MutationObserver){new MutationObserver(function(){window.clearTimeout(t);t=window.setTimeout(function(){enhanceCards();enhanceHeader();enhanceProduct();sync();},120);}).observe(doc.body,{childList:true,subtree:true});}
}
if(doc.readyState==='loading'){doc.addEventListener('DOMContentLoaded',boot);}else{boot();}
window.addEventListener('pageshow',function(e){if(e.persisted){sync();renderPage();}});
window.LuxeWishlist={list:load,toggle:toggle,has:has};
})();
